import { stdBadgeActive, stdBadgeMuted, stdModalHeaderBar } from '../adminlayout/designStandard';

export const pageStyle = {
  display: 'grid',
  gap: 14,
  maxWidth: 1440,
  margin: '0 auto',
  paddingBottom: 32,
};

export const headerStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: 16,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
};

export const titleStyle = {
  margin: 0,
  fontSize: 22,
  fontWeight: 900,
  color: 'var(--text)',
};

export const subTextStyle = {
  marginTop: 6,
  fontSize: 13,
  color: 'var(--text-sub)',
  fontWeight: 700,
};

export const toolbarStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: 12,
  display: 'flex',
  gap: 8,
  alignItems: 'center',
  flexWrap: 'wrap',
};

export const summaryGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
  gap: 8,
};

export const summaryCardStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: '12px 14px',
};

export const tableShellStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  overflow: 'hidden',
};

export const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
};

export const thStyle = {
  padding: '10px 8px',
  borderBottom: '1px solid var(--border)',
  background: 'var(--bg-muted)',
  color: 'var(--text-sub)',
  fontSize: 12,
  fontWeight: 900,
  textAlign: 'left',
};

export const tdStyle = {
  padding: '9px 8px',
  borderBottom: '1px solid var(--border)',
  color: 'var(--text)',
  fontSize: 13,
  verticalAlign: 'middle',
};

export const inputStyle = {
  height: 34,
  border: '1px solid var(--border)',
  borderRadius: 7,
  background: 'var(--bg-input, var(--bg-card))',
  color: 'var(--text)',
  padding: '0 10px',
  outline: 'none',
  fontWeight: 700,
};

export const buttonBase = {
  height: 34,
  border: '1px solid var(--border)',
  borderRadius: 12,
  background: 'var(--bg-card)',
  color: 'var(--text-sub)',
  padding: '0 14px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  fontWeight: 800,
  fontSize: 12,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export function primaryButton(disabled = false) {
  return {
    ...buttonBase,
    border: '1px solid var(--std-btn, #0f172a)',
    background: 'var(--std-btn, #0f172a)',
    color: '#fff',
    opacity: disabled ? 0.65 : 1,
    cursor: disabled ? 'wait' : 'pointer',
  };
}

export function dangerButton(disabled = false) {
  return {
    ...buttonBase,
    border: '1px solid rgba(220,38,38,0.42)',
    background: 'rgba(220,38,38,0.10)',
    color: '#dc2626',
    opacity: disabled ? 0.65 : 1,
    cursor: disabled ? 'wait' : 'pointer',
  };
}

export function badgeStyle(tone) {
  // 디자인 표준(직원 관리 기준): 긍정/활성 = 연파랑 stdBadgeActive, 중립/비활성 = 회색 stdBadgeMuted.
  // red(수습검토)·amber(계약임박)는 긴급도 의미가 있어 색을 유지한다(스타일 통일 범위 밖의 의미 색).
  if (tone === 'green') return { ...stdBadgeActive, whiteSpace: 'nowrap' };
  const map = {
    red: ['rgba(220,38,38,0.13)', '#dc2626', 'rgba(220,38,38,0.32)'],
    amber: ['rgba(217,119,6,0.14)', '#b45309', 'rgba(217,119,6,0.32)'],
  };
  if (!map[tone]) return { ...stdBadgeMuted, whiteSpace: 'nowrap' };
  const [background, color, border] = map[tone];
  return {
    display: 'inline-flex',
    alignItems: 'center',
    height: 24,
    padding: '0 8px',
    borderRadius: 999,
    border: `1px solid ${border}`,
    background,
    color,
    fontSize: 12,
    fontWeight: 900,
    whiteSpace: 'nowrap',
  };
}

export const modalBackdropStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15,23,42,0.58)',
  zIndex: 50,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 16,
};

export const modalStyle = {
  width: 'min(860px, 100%)',
  maxHeight: '88vh',
  overflow: 'auto',
  borderRadius: 10,
  border: '1px solid var(--border)',
  background: 'var(--bg-card)',
  boxShadow: '0 24px 80px rgba(0,0,0,0.28)',
};

// 모달 헤더 표준(2026-08-31): 검정 밴드 #0f172a — 카드 라운드(10)에 맞춘 radius.
export const modalHeaderStyle = {
  ...stdModalHeaderBar(10),
};
